var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"error","indeterminate":""}})],1),(_vm.message)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"text-h5 secondary--text"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }